/**
 * Escape text before inserting into map InfoWindow HTML strings.
 * Keep & first so later entities are not double-encoded incorrectly.
 */
function escapeHtml (value) {
  if (value == null) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

module.exports = {
  escapeHtml
}
